export interface Specification<T> {
   isSatisfiedBy(candidate: T): boolean;
   and(other: Specification<T>): Specification<T>;
   or(other: Specification<T>): Specification<T>;
}

export abstract class AbstractSpecification<T> implements Specification<T> {
   public abstract isSatisfiedBy: (candidate: T) => boolean;

   public and(other: Specification<T>): Specification<T> {
       
      return new AndSpecification(this, other);
   }

   public or(other: Specification<T>): Specification<T> {
       
      return new OrSpecification(this, other);
   }
}

export class AndSpecification<T> extends AbstractSpecification<T> {
   constructor(private one: Specification<T>, private other: Specification<T>) {
      super();
   }

   isSatisfiedBy = (candidate: T) => this.one.isSatisfiedBy(candidate) && this.other.isSatisfiedBy(candidate);
}

export class OrSpecification<T> extends AbstractSpecification<T> {
   constructor(private one: Specification<T>, private other: Specification<T>) {
      super();
   }

   public isSatisfiedBy = (candidate: T) => this.one.isSatisfiedBy(candidate) || this.other.isSatisfiedBy(candidate);
}
